import buyModel from "./component/bugModel.vue"

const baseData = {}

const list = [
  { name: "当前剩余可发送短信条数：", value: "n条" },
  {
    name: "购买短信包，套餐选择：",
    value: "单条0.06元，发送成功计费",
    button: {
      text: "点击购买1000条短信发送额度",
    }
  }
];

const funcs = {};

funcs.openModel = function() {
  console.log(this.$refs)
  this.$refs.dialogRef.init();
};

export default {
  name: "Index",
  props: {},
  components: {
    buyModel
  },
  data() {
    return { list, ...baseData };
  },
  methods: { ...funcs },
  created() {}
};



// WEBPACK FOOTER //
// ./src/views/collection/sms_package/contact.js